import { api } from '../../DefaultService';
import {
    IMoovsecCreateProps,
    IMoovsecProps,
    IMoovsecUpdateParams,
} from './types';

const ENDPOINT = '/v1/integrations/moovsec';

export const createMoovsecIntegrationAsync = async (data: IMoovsecCreateProps) => {
    return await api
        .post(`${ENDPOINT}`, data)
        .then((response) => response.data)
        .catch((error) => {
            throw new Error(error?.response?.data?.message || 'Erro interno do servidor!');
        });
};

export const getMoovsecIntegrationByIdAsync = async (id: number): Promise<IMoovsecProps> => {
    return await api
        .get<IMoovsecProps>(`${ENDPOINT}/${id}`)
        .then((response) => response.data)
        .catch((error) => {
            throw new Error(error?.response?.data?.message || 'Erro interno do servidor!');
        });
};

export const updateMoovsecIntegrationAsync = async ({ id, data }: IMoovsecUpdateParams) => {
    return await api
        .put(`${ENDPOINT}/${id}`, data)
        .then((response) => response.data)
        .catch((error) => {
            throw new Error(error?.response?.data?.message || 'Erro interno do servidor!');
        });
};

export const deleteMoovsecIntegrationAsync = async (id: number) => {
    return await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
        throw new Error(error?.response?.data?.message || 'Erro interno do servidor!');
    });
};
